import { NumberFilter, Filter } from '@playq/octopus-common';

import { IPreviewComponentProps } from './IPreviewComponentProps';

export function NumberPreview({ filter, format }: IPreviewComponentProps) {
  if (!(filter instanceof NumberFilter)) {
    return null;
  }

  if (format !== undefined) {
    return format(filter);
  }

  const { left } = filter;
  const { right } = filter;

  return (
    <>
      {}
      {filter.expression} -&gt; {right ? `${left} - ${right}` : left}
    </>
  );
}

NumberPreview.canPreview = (filter: Filter) => filter instanceof NumberFilter;
